// import { motion } from "framer-motion";
// import {
//   Code,
//   Smartphone,
//   ShoppingCart,
//   Cloud,
//   BarChart3,
//   Zap,
//   ArrowRight,
//   CheckCircle,
//   Headphones,
//   Database,
//   Brain,
//   ImageIcon,
//   Video,
//   Cable as Cube,
//   Layers,
//   Tag,
//   MessageSquare,
// } from "lucide-react";

// import { Link } from "react-router-dom";

// export default function ServiceDetail() {
//    const services = [
//      {
//        id: "web",
//        icon: Code,
//        title: "Website Development",
//        details:
//          "We create responsive, fast-loading websites that showcase your brand and drive conversions.",
//        features: [
//          "Responsive Design",
//          "SEO Optimized",
//          "Fast Performance",
//          "Secure & Scalable",
//        ],
//      },
//      {
//        id: "mobile",
//        icon: Smartphone,
//        title: "Mobile App Development",
//        details:
//          "Build powerful mobile applications that engage your users with stunning UI and performance.",
//        features: [
//          "iOS & Android",
//          "Cross-Platform",
//          "User-Friendly UI",
//          "Real-time Sync",
//        ],
//      },
//      {
//        id: "ecommerce",
//        icon: ShoppingCart,
//        title: "E-Commerce Development",
//        details:
//          "Launch your online business with secure payments and inventory management.",
//        features: [
//          "Shopping Cart",
//          "Payment Gateway",
//          "Inventory Mgmt",
//          "Analytics",
//        ],
//      },
//      {
//        id: "cloud",
//        icon: Cloud,
//        title: "Cloud Solutions",
//        details: "Migrate, deploy and scale on AWS, Azure and Google Cloud.",
//        features: ["Cloud Migration", "DevOps", "CI/CD", "Monitoring"],
//      },
//      {
//        id: "digital",
//        icon: BarChart3,
//        title: "Digital Marketing",
//        details:
//          "Grow traffic, leads and sales using modern digital strategies.",
//        features: ["SEO", "Google Ads", "Social Media", "Content Marketing"],
//      },
//      {
//        id: "transcription",
//        icon: Headphones,
//        title: "Multi-Linguistic Transcription & Translation",
//        description: "Professional transcription and translation services",
//        details:
//          "Convert audio to text and translate across 50+ languages with AI-powered accuracy and human quality assurance.",
//        features: [
//          "50+ Languages",
//          "Real-time Processing",
//          "Quality Assurance",
//          "Secure Delivery",
//        ],
//      },
//      {
//        id: "audio-voice",
//        icon: Headphones,
//        title: "Audio & Voice Dataset Services",
//        description: "High-quality audio datasets for AI training",
//        details:
//          "Curated audio and voice datasets for machine learning models, speech recognition, and voice AI applications.",
//        features: [
//          "Native Speakers",
//          "Multiple Accents",
//          "Noise Profiles",
//          "Metadata Tagged",
//        ],
//      },
//      {
//        id: "nlp-llm",
//        icon: Brain,
//        title: "NLP & LLM Dataset Services",
//        description: "Specialized datasets for language models",
//        details:
//          "Premium text datasets, conversational AI training data, and domain-specific language model datasets.",
//        features: [
//          "Domain Specific",
//          "Annotated Data",
//          "High Accuracy",
//          "Scalable",
//        ],
//      },
//      {
//        id: "image-photo",
//        icon: ImageIcon,
//        title: "Image & Photo Dataset Services",
//        description: "Comprehensive image datasets for computer vision",
//        details:
//          "Large-scale annotated image datasets for object detection, classification, and deep learning projects.",
//        features: [
//          "High Resolution",
//          "Detailed Annotations",
//          "Diverse Subjects",
//          "Quality Control",
//        ],
//      },
//      {
//        id: "video",
//        icon: Video,
//        title: "Video Dataset Services",
//        description: "Video data for action recognition and analysis",
//        details:
//          "Professional video datasets with frame-level annotations for action recognition and video analysis AI.",
//        features: [
//          "4K Quality",
//          "Frame Annotations",
//          "Action Tags",
//          "Temporal Data",
//        ],
//      },
//      {
//        id: "2d3d",
//        icon: Cube,
//        title: "2D & 3D Dataset Services",
//        description: "Spatial and dimensional data for advanced AI",
//        details:
//          "High-quality 2D and 3D datasets for computer vision, object detection, and 3D model training with precise annotations.",
//        features: [
//          "Point Clouds",
//          "3D Annotations",
//          "2D/3D Conversion",
//          "CAD Integration",
//        ],
//      },
//      {
//        id: "ai-training",
//        icon: Brain,
//        title: "AI Training Data Services",
//        description: "Specialized training datasets for machine learning",
//        details:
//          "Custom-curated training data tailored to your AI model requirements with quality validation and bias reduction.",
//        features: [
//          "Custom Curation",
//          "Bias Reduction",
//          "Quality Validation",
//          "Scalable Generation",
//        ],
//      },
//      {
//        id: "categorizing-tagging",
//        icon: Tag,
//        title: "Categorizing & Tagging Services",
//        description: "Professional data classification and labeling",
//        details:
//          "Expert categorization and tagging services for organizing and structuring data for machine learning and analytics.",
//        features: [
//          "Multi-level Tagging",
//          "Custom Taxonomies",
//          "Metadata Enrichment",
//          "Automated Validation",
//        ],
//      },
//      {
//        id: "phonetic-transcription",
//        icon: MessageSquare,
//        title: "Phonetic Transcription & Tagging",
//        description: "Precise phonetic level transcription services",
//        details:
//          "Detailed phonetic transcription with linguistic tagging for speech recognition, linguistics research, and pronunciation analysis.",
//        features: [
//          "IPA Symbols",
//          "Linguistic Tags",
//          "Accent Variation",
//          "Prosody Marking",
//        ],
//      },
//    ];

//   return (
//     <div className="bg-[#f8fafc] text-[#0f172a] font-inter">
//       {/* HEADER (LIKE SCREENSHOT) */}
//       <section className="bg-gradient-to-r from-[#071c34] to-[#0f2a44] py-24 text-center text-white">
//         <h1 className="text-5xl font-bold mb-4">Our Services</h1>
//         <p className="text-white/80 max-w-2xl mx-auto">
//           Comprehensive digital solutions tailored to your business needs
//         </p>
//       </section>

//       {/* SERVICES */}
//       <section className="py-24">
//         <div className="max-w-7xl mx-auto px-6">
//           {/* <h2 className="text-4xl font-bold text-center mb-16 text-[#0f2a44]">
//             Our Core Services
//           </h2> */}

//           <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
//             {services.map((s, i) => {
//               const Icon = s.icon;
//               return (
//                 <motion.div
//                   key={i}
//                   whileHover={{ y: -6 }}
//                   className="bg-white border border-gray-200 rounded-xl p-8 shadow-sm hover:shadow-lg transition"
//                 >
//                   <div className="w-14 h-14 rounded-lg bg-[#1e60ff]/10 flex items-center justify-center mb-6">
//                     <Icon className="text-[#1e60ff]" size={26} />
//                   </div>

//                   <h3 className="text-xl font-bold mb-3 text-[#0f2a44]">
//                     {s.title}
//                   </h3>
//                   <p className="text-gray-600 mb-6">{s.desc}</p>

//                   <div className="space-y-2 mb-6">
//                     {s.features.map((f, idx) => (
//                       <div
//                         key={idx}
//                         className="flex gap-2 items-center text-sm"
//                       >
//                         <CheckCircle size={15} className="text-[#1e60ff]" />
//                         <span>{f}</span>
//                       </div>
//                     ))}
//                   </div>

//                   <Link
//                     to={`/services/${s.id}`}
//                     className="inline-flex items-center gap-2 font-medium text-[#1e60ff] hover:gap-3 transition-all text-sm"
//                   >
//                     Learn More <ArrowRight size={16} />
//                   </Link>
//                 </motion.div>
//               );
//             })}
//           </div>
//         </div>
//       </section>

//       {/* CTA (UPDATED) */}
//       <section className="bg-[#eef4ff] py-20 text-center">
//         <h2 className="text-3xl font-bold mb-3 text-[#0f2a44]">
//           Ready to Scale Your Business?
//         </h2>
//         <p className="text-gray-600 mb-6">
//           Talk to our experts and get a free project consultation
//         </p>
//         <Link
//           to="/contact"
//           className="inline-flex items-center gap-2 bg-[#1e60ff] text-white px-6 py-3 rounded-md text-sm font-semibold hover:bg-blue-600 transition"
//         >
//           Start Your Project <ArrowRight size={16} />
//         </Link>
//       </section>
//     </div>
//   );
// }

import { motion } from "framer-motion";
import {
  Code,
  Smartphone,
  ShoppingCart,
  Cloud,
  BarChart3,
  ArrowRight,
  CheckCircle2,
  Headphones,
  Brain,
  ImageIcon,
  Video,
  Database,
  Tag,
  MessageSquare,
  Terminal,
  ShieldCheck,
  Cable as Cube,
} from "lucide-react";
import { Link } from "react-router-dom";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
};

export default function ServiceDetail() {
  const services = [
    {
      id: "web",
      icon: Code,
      title: "Website Development",
      desc: "Architecting responsive, high-performance web ecosystems designed for enterprise scale.",
      features: [
        "Advanced React Frameworks",
        "SEO Orchestration",
        "Optimized Vitals",
        "Hardened Security",
      ],
    },
    {
      id: "mobile",
      icon: Smartphone,
      title: "Mobile App Development",
      desc: "Engineering native and cross-platform mobile solutions with sub-second latency.",
      features: [
        "iOS & Android Native",
        "Flutter/React Native",
        "Real-time Data Sync",
        "Biometric Integration",
      ],
    },
    {
      id: "ecommerce",
      icon: ShoppingCart,
      title: "E-Commerce Solutions",
      desc: "Deploying conversion-focused storefronts with integrated billing and inventory logic.",
      features: [
        "Secure Payment Gateways",
        "Inventory Automation",
        "Predictive Analytics",
        "CRM Integration",
      ],
    },
    {
      id: "cloud",
      icon: Cloud,
      title: "Cloud & DevOps",
      desc: "Provisioning resilient cloud infrastructure on AWS, Azure, and Google Cloud.",
      features: [
        "Infrastructure as Code",
        "CI/CD Pipelines",
        "24/7 Telemetry",
        "Container Orchestration",
      ],
    },
    {
      id: "ai-training",
      icon: Brain,
      title: "AI Training Data",
      desc: "Engineering high-fidelity ground truth datasets tailored for specialized model convergence.",
      features: [
        "Ethical Sourcing",
        "Bias Mitigation",
        "Validation Matrix",
        "Scalable Generation",
      ],
    },
    {
      id: "transcription",
      icon: Headphones,
      title: "Transcription & Translation",
      desc: "Multi-linguistic conversion powered by native speakers and document translator logic.",
      features: [
        "50+ Languages Supported",
        "IPA Precision",
        "Linguistic Review",
        "Secure Data Handoff",
      ],
    },
    {
      id: "nlp-llm",
      icon: Database,
      title: "NLP & LLM Datasets",
      desc: "Premium corpora and instruction-tuning sets for next-generation language architectures.",
      features: [
        "Domain-Specific Corpora",
        "Entity Annotation",
        "Sentiment Polarity",
        "Metadata Enrichment",
      ],
    },
    {
      id: "image-photo",
      icon: ImageIcon,
      title: "Computer Vision Data",
      desc: "Large-scale annotated visual datasets for object detection and pixel-level segmentation.",
      features: [
        "4K Resolution Ingestion",
        "Sub-pixel Precision",
        "Diverse Environments",
        "Quality Verification",
      ],
    },
    {
      id: "video",
      icon: Video,
      title: "Video Dataset Services",
      desc: "Frame-accurate temporal annotations for motion analysis and action recognition models.",
      features: [
        "Temporal Tagging",
        "Motion Trajectories",
        "Sequence Continuity",
        "Action Logic",
      ],
    },
    {
      id: "2d3d",
      icon: Cube,
      title: "2D & 3D Dataset Services",
      description: "Spatial and dimensional data for advanced AI",
      desc:
        "High-quality 2D and 3D datasets for computer vision, object detection, and 3D model training with precise annotations.",
      features: [
        "Point Clouds",
        "3D Annotations",
        "2D/3D Conversion",
        "CAD Integration",
      ],
    },
    {
      id: "ai-training",
      icon: Brain,
      title: "AI Training Data Services",
      description: "Specialized training datasets for machine learning",
      desc:
        "Custom-curated training data tailored to your AI model requirements with quality validation and bias reduction.",
      features: [
        "Custom Curation",
        "Bias Reduction",
        "Quality Validation",
        "Scalable Generation",
      ],
    },
    {
      id: "categorizing-tagging",
      icon: Tag,
      title: "Categorizing & Tagging Services",
      description: "Professional data classification and labeling",
      desc:
        "Expert categorization and tagging services for organizing and structuring data for machine learning and analytics.",
      features: [
        "Multi-level Tagging",
        "Custom Taxonomies",
        "Metadata Enrichment",
        "Automated Validation",
      ],
    },
    {
      id: "phonetic-transcription",
      icon: MessageSquare,
      title: "Phonetic Transcription & Tagging",
      description: "Precise phonetic level transcription services",
      desc:
        "Detailed phonetic transcription with linguistic tagging for speech recognition, linguistics research, and pronunciation analysis.",
      features: [
        "IPA Symbols",
        "Linguistic Tags",
        "Accent Variation",
        "Prosody Marking",
      ],
    },
  ];

  return (
    <main className="bg-white font-inter selection:bg-indigo-100 text-[#0f172a]">
      {/* ================= HERO SECTION ================= */}
      <section className="relative h-[450px] flex items-center overflow-hidden bg-[#0f172a]">
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#0f172a]/95 to-transparent z-10" />

        {/* Technical Grid Overlay */}
        <div
          className="absolute inset-0 opacity-[0.05] pointer-events-none z-10"
          style={{
            backgroundImage: `radial-gradient(#4f46e5 0.5px, transparent 0.5px)`,
            backgroundSize: "30px 30px",
          }}
        />

        <div className="relative max-w-7xl mx-auto px-6 w-full z-20">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-bold tracking-[0.3em] uppercase mb-6">
              Engineering Capabilities
            </div>
            <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 tracking-tight leading-tight">
              Enterprise{" "}
              <span className="text-indigo-400">Digital Solutions.</span>
            </h1>
            <p className="text-lg text-slate-300 max-w-2xl font-light leading-relaxed">
              We architect high-fidelity software ecosystems and multilingual
              data pipelines engineered for global scalability and
              mission-critical performance.
            </p>
          </motion.div>
        </div>
      </section>

      {/* ================= SERVICES GRID ================= */}
      <section className="py-24 bg-[#f8fafc]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((s, i) => (
              <motion.div
                key={i}
                {...fadeUp}
                transition={{ delay: i * 0.1 }}
                className="group bg-white border border-slate-200 rounded-2xl p-8 shadow-sm hover:shadow-xl hover:border-indigo-100 transition-all duration-300 flex flex-col h-full"
              >
                <div className="w-14 h-14 rounded-xl bg-slate-50 flex items-center justify-center mb-8 group-hover:bg-indigo-600 group-hover:text-white transition-all">
                  <s.icon
                    size={26}
                    className="text-indigo-600 group-hover:text-white transition-colors"
                  />
                </div>

                <h3 className="text-xl font-bold mb-4 tracking-tight text-[#0f2a44]">
                  {s.title}
                </h3>
                <p className="text-slate-500 text-sm font-light leading-relaxed mb-8 flex-grow">
                  {s.desc}
                </p>

                <div className="space-y-3 mb-8 border-t border-slate-50 pt-6">
                  {s.features.map((f, idx) => (
                    <div
                      key={idx}
                      className="flex gap-3 items-center text-[13px] font-medium text-slate-700"
                    >
                      <CheckCircle2
                        size={14}
                        className="text-indigo-600 shrink-0"
                      />
                      <span>{f}</span>
                    </div>
                  ))}
                </div>

                <Link
                  to={`/services/${s.id}`}
                  className="inline-flex items-center gap-2 font-bold text-indigo-600 group-hover:gap-3 transition-all text-xs uppercase tracking-widest"
                >
                  Technical Specs <ArrowRight size={14} />
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= TRUST SECTION ================= */}
      {/* <section className="py-20 bg-white border-t border-slate-100">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-12">
          <div className="max-w-xl">
            <h2 className="text-3xl font-bold mb-4 tracking-tight">
              Hardened for Production
            </h2>
            <p className="text-slate-500 font-light leading-relaxed">
              Our engineering workflows are built on SOC2-compliant
              infrastructures, ensuring your proprietary data and application
              code remain secure throughout the lifecycle.
            </p>
          </div>
          <div className="flex flex-wrap gap-6">
            <div className="px-6 py-4 bg-slate-50 rounded-2xl border border-slate-100 flex items-center gap-3">
              <ShieldCheck className="text-indigo-600" />
              <span className="text-sm font-bold uppercase tracking-widest">
                ISO Certified
              </span>
            </div>
            <div className="px-6 py-4 bg-slate-50 rounded-2xl border border-slate-100 flex items-center gap-3">
              <Terminal className="text-indigo-600" />
              <span className="text-sm font-bold uppercase tracking-widest">
                DevSecOps Ready
              </span>
            </div>
          </div>
        </div>
      </section> */}

      {/* ================= FINAL CTA ================= */}
      <section className="bg-[#eef4ff] py-24 text-center relative overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-[radial-gradient(circle_at_center,_#4f46e50a_0%,_transparent_70%)]" />

        <div className="relative z-10 max-w-4xl mx-auto px-6">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#0f2a44] tracking-tight">
            Build Your Next Architectural Milestone.
          </h2>
          <p className="text-slate-500 mb-10 text-lg font-light leading-relaxed mx-auto max-w-2xl">
            Discuss your technical roadmap with our engineering lead and
            discover how we can optimize your digital infrastructure.
          </p>
          <div className="flex justify-center gap-4">
            <Link
              to="/contact"
              className="bg-[#0f172a] text-white px-10 py-4 rounded-xl font-bold text-sm uppercase tracking-widest hover:bg-indigo-600 transition-all shadow-xl shadow-indigo-100"
            >
              Initiate Consultation
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}